import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FeatureFlagsService } from '../../services/feature-flags.service';

/**
 * Detects backend maintenance responses and forces the app into maintenance mode.
 * Backend sends 503 with header `X-Maintenance-Mode: true` (and JSON body
 * `{ error: 'maintenance' }`) for any non-whitelisted route while maintenance
 * is active.
 */
export const maintenanceInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const featureFlags = inject(FeatureFlagsService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && isMaintenanceResponse(error)) {
        featureFlags.setMaintenanceMode(true);
      }
      return throwError(() => error);
    })
  );
};

function isMaintenanceResponse(error: HttpErrorResponse): boolean {
  if (error.status !== 503) {
    return false;
  }
  if (error.headers?.get('X-Maintenance-Mode') === 'true') {
    return true;
  }
  const body: any = error.error;
  return body?.error === 'maintenance';
}
